/* eslint-disable no-nested-ternary */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridActionsCellItem, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Button, Stack, Typography, Chip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import LoadingSkeleton from '../../utils/LoadingSkeleton';
import NoRowsOverlay from '../../utils/NoRowOverlay';
import CurrencyEdit from './edit';
import CurrencyDelete from './delete';
import CurrencyAdd from './add';
import CurrencyAction from '../../store/actions/CurrencyAction';
import CopyInput from '../../components/CopyInput';
import useHasPermission from '../../utils/useHasPermission';
import { currency, show, store, update, destroy } from '../../utils/constants';

function QuickSearchToolbar() {
  const [addOpen, setAddOpen] = useState(false);
  return (
    <Box
      className="tableTopWrap page__title"
      sx={{
        borderBottom: '1px solid rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 3
      }}
    >
      <Stack direction="row" sx={{ ml: 'auto' }} spacing={2} className="MuiDataGrid-Search">
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput) => searchInput.split(',').map((value) => value.trim())}
          quickFilterFormatter={(quickFilterValues) => quickFilterValues.join(', ')}
          debounceMs={800} // time before applying the new quick filter value
          variant="outlined"
          size="small"
          sx={{ pb: 0, maxWidth: '275px' }}
        />
        {useHasPermission(currency, store) && (
          <Button
            className="button_primary"
            variant="contained"
            size="small"
            color="secondary"
            onClick={() => {
              setAddOpen(true);
            }}
          >
            Add Currency
          </Button>
        )}
      </Stack>
      {addOpen === true ? (
        <CurrencyAdd openmodal={addOpen} onCloseModal={() => setAddOpen(false)} />
      ) : (
        ''
      )}
    </Box>
  );
}

export default function CurrencyList() {
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10
  });

  const [sortInfo, setSortInfo] = React.useState({
    sortField: '',
    sort: ''
  });
  const [searchKey, setSearchKey] = React.useState('');
  const [editOpen, setEditOpen] = React.useState(false);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [itemID, setItemID] = React.useState('');
  const [rowCountState, setRowCountState] = React.useState(0);
  const [data, setData] = React.useState([]);
  const dispatch = useDispatch();
  const { currencyData, isLoading } = useSelector((state) => state.currency); // Replace 'data' with your reducer name
  const { paginationData, sortingData, keyword } = useSelector(
    (state) => state.currency.queryParams
  );

  useEffect(() => {
    dispatch(CurrencyAction.updateQueryParams(paginationModel, sortInfo, searchKey));
    dispatch(CurrencyAction.getAll(paginationModel, sortInfo, searchKey));
  }, [dispatch, paginationModel, sortInfo, searchKey]);

  useEffect(() => {
    if (currencyData) {
      if (currencyData.data) {
        setData(
          currencyData.data.map((item) => {
            if (item.status === 1) {
              return { ...item, checked: true };
            }
            return { ...item, checked: false };
          })
        );
      } else {
        setData([]);
      }
      setRowCountState((prevRowCountState) =>
        currencyData.total !== undefined ? currencyData.total : prevRowCountState
      );
    }
  }, [currencyData]);

  useEffect(() => {
    if (paginationData) {
      setPaginationModel(paginationData);
    }
    if (sortingData) {
      setSortInfo(sortingData);
    }
    if (keyword) {
      setSearchKey(keyword);
    }
  }, [paginationData, keyword, sortingData]);

  const handleSwitchOnChange = (id, status) => {
    const formData = {
      status: status === 1 ? 2 : 1
    };
    // Dispatch the action with formData
    dispatch(CurrencyAction.update(id, formData));
  };

  const columns = [
    {
      field: 'unique_id',
      headerName: '',
      sortable: false,
      align: 'left',
      flex: 0.3,
      renderCell: (params) => {
        if (params && params.value) {
          return <CopyInput id={params.value} />;
        }
        return null;
      }
    },
    {
      field: 'name',
      headerName: 'Currency Name',
      flex: 1
    },
    {
      field: 'symbol',
      headerName: 'Currency Symbol',
      flex: 1
    },
    {
      field: 'short_name',
      headerName: 'Currency Short Name',
      flex: 1
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => {
        if (params && params.value) {
          return params.value === 1 ? (
            <Chip label="Active" color="success" />
          ) : (
            <Chip label="Inactive" color="lignhtwarning" />
          );
        }
        return null;
      }
    },
    useHasPermission(currency) && {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      flex: 1,
      getActions: (params) => [
        currency && useHasPermission(currency, show) ? (
          <GridActionsCellItem
            icon={<i className="icon-view" />}
            className="actionBtn"
            title="View"
            key={0}
            label="View"
            onClick={() => {
              setEditOpen(true);
              setItemID(params.id);
            }}
            // showInMenu
          />
        ) : (
          <span />
        ),
        currency && useHasPermission(currency, update) ? (
          params.row.status === 1 ? (
            <GridActionsCellItem
              icon={<IndeterminateCheckBoxOutlinedIcon color="error" />}
              className="actionBtn"
              key={1}
              // color="primary"
              title="In Active"
              label="Toggle Admin"
              onClick={() => {
                handleSwitchOnChange(params.id, params.row.status);
              }}
            />
          ) : (
            <GridActionsCellItem
              icon={<CheckBoxOutlinedIcon color="success" />}
              className="actionBtn"
              title="Active"
              key={1}
              // color="primary"
              label="Toggle Admin"
              onClick={() => {
                handleSwitchOnChange(params.id, params.row.status);
              }}
            />
          )
        ) : (
          <span />
        ),
        currency && useHasPermission(currency, destroy) ? (
          <GridActionsCellItem
            icon={<i className="icon-delete" />}
            className="actionBtn"
            title="Delete"
            key={2}
            label="Delete"
            onClick={() => {
              setDeleteOpen(true);
              setItemID(params.id);
            }}
            // showInMenu
          />
        ) : (
          <span />
        )
      ]
    }
  ];

  const handleSortModelChange = React.useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0];
      const sortData = {
        sortField: field,
        sort
      };
      setSortInfo(sortData);
    }
    // else {
    //   dispatch(CurrencyAction.getAll(paginationModel, sortInfo));
    // }
    // eslint-disable-next-line
  }, []);

  const onFilterChange = React.useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    const searchKeyword = filterModel.quickFilterValues[0];
    setSearchKey(searchKeyword);
    setPaginationModel({ page: 0, pageSize: 10 });
    // dispatch(CurrencyAction.getAll(paginationModel, sortInfo, keyword));
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <div className="pageTitleWrap">
        <Typography className="" component="h2" variant="h2">
          Currencies
        </Typography>
      </div>
      <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
        <DataGrid
          rows={data}
          getRowId={(row) => row._id}
          rowCount={rowCountState}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10
              }
            }
          }}
          autoHeight
          sx={{ minHeight: 650, '--DataGrid-overlayHeight': '300px' }}
          disableColumnFilter
          rowHeight={50}
          slots={{
            toolbar: QuickSearchToolbar,
            loadingOverlay: LoadingSkeleton,
            noRowsOverlay: NoRowsOverlay
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          filterMode="server"
          onFilterModelChange={onFilterChange}
          disableRowSelectionOnClick
          loading={isLoading}
        />
      </Box>

      {editOpen === true ? (
        <CurrencyEdit
          openmodal={editOpen}
          itemId={itemID}
          onCloseModal={() => setEditOpen(false)}
        />
      ) : (
        ''
      )}
      {deleteOpen === true ? (
        <CurrencyDelete
          openmodal={deleteOpen}
          itemId={itemID}
          onCloseModal={() => setDeleteOpen(false)}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
